/*-----------------------------------------------------------------------------/
/ Custom Theme JS — ajax ATC, drawer funnel polish, GTM funnel events
/
/ GTM / dataLayer events (wire as Custom Event triggers):
/   sg_add_to_cart
/     - sg_source: homepage_hero | homepage_lineup | homepage_sticky | ajax_form
/     - sg_variant_id, sg_item_count, sg_unique_products
/   sg_cart_item_remove
/     - sg_item_count, sg_unique_products, sg_prev_item_count
/   sg_cart_qty_change
/     - sg_item_count, sg_unique_products
/   sg_cart_drawer_checkout
/     - sg_item_count, sg_unique_products, sg_line_count
/     - sg_checkout_type: checkout | express
/-----------------------------------------------------------------------------*/

(function () {
  var JUST_ADDED_KEY = 'sg_just_added_key';
  var JUST_ADDED_VARIANT = 'sg_just_added_variant';
  var JUST_ADDED_TITLE = 'sg_just_added_title';

  function pushFunnelEvent(name, payload) {
    window.dataLayer = window.dataLayer || [];
    var data = { event: name };
    if (payload) {
      for (var k in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, k)) data[k] = payload[k];
      }
    }
    window.dataLayer.push(data);
  }

  function cartSnapshot() {
    try {
      var products = window.theme.cart.store.getState().products || {};
      var items = products.items || [];
      var productIds = {};
      for (var i = 0; i < items.length; i++) {
        productIds[String(items[i].product_id)] = true;
      }
      return {
        item_count: products.item_count || 0,
        line_count: items.length,
        unique_products: Object.keys(productIds).length,
        items: items
      };
    } catch (e) {
      return { item_count: 0, line_count: 0, unique_products: 0, items: [] };
    }
  }

  function whenCartReady(cb) {
    if (window.theme && window.theme.cart && window.theme.cart.store) {
      cb();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.theme && window.theme.cart && window.theme.cart.store) {
        clearInterval(timer);
        cb();
      } else if (tries > 80) {
        clearInterval(timer);
      }
    }, 50);
  }

  function openCartDrawer() {
    if (window.theme && typeof window.theme.mfpOpen === 'function' && window.theme.cart_ajax) {
      window.theme.mfpOpen('cart');
    }
  }

  function resolveJustAddedKey() {
    var storedKey = sessionStorage.getItem(JUST_ADDED_KEY);
    var variantId = sessionStorage.getItem(JUST_ADDED_VARIANT);
    var items = cartSnapshot().items;

    if (variantId) {
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].variant_id) === String(variantId)) {
          return items[i].key;
        }
      }
    }
    if (storedKey) {
      for (var j = 0; j < items.length; j++) {
        var k = items[j].key || '';
        if (k === storedKey || k.indexOf(storedKey) === 0 || storedKey.indexOf(k) === 0) {
          return items[j].key;
        }
      }
      return storedKey;
    }
    return null;
  }

  function highlightJustAdded() {
    var key = resolveJustAddedKey();
    if (!key) return;

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      var el = document.querySelector('cart-item[key="' + key.replace(/"/g, '\\"') + '"]');
      if (!el) {
        var nodes = document.querySelectorAll('cart-item[key]');
        for (var i = 0; i < nodes.length; i++) {
          var k = nodes[i].getAttribute('key') || '';
          if (k === key || k.indexOf(key) === 0 || key.indexOf(k) === 0) {
            el = nodes[i];
            break;
          }
        }
      }
      if (el) {
        clearInterval(timer);
        el.classList.add('is-just-added');
        setTimeout(function () {
          el.classList.remove('is-just-added');
        }, 1800);
        sessionStorage.removeItem(JUST_ADDED_KEY);
        sessionStorage.removeItem(JUST_ADDED_VARIANT);
      } else if (attempts > 40) {
        clearInterval(timer);
        sessionStorage.removeItem(JUST_ADDED_KEY);
        sessionStorage.removeItem(JUST_ADDED_VARIANT);
      }
    }, 50);
  }

  function updateMultiItemNote() {
    var snap = cartSnapshot();
    var drawers = document.querySelectorAll('.js-cart-draw .cart__wrapper, .mfp-content .cart__wrapper');
    for (var d = 0; d < drawers.length; d++) {
      var wrapper = drawers[d];
      var note = wrapper.querySelector('.sg-cart-multi-note');
      if (!note) {
        var contents = wrapper.querySelector('.cart__contents');
        if (!contents) continue;
        note = document.createElement('p');
        note.className = 'sg-cart-multi-note';
        note.setAttribute('role', 'status');
        contents.insertBefore(note, contents.firstChild);
      }

      if (snap.unique_products > 1) {
        var addedTitle = sessionStorage.getItem(JUST_ADDED_TITLE);
        var otherTitles = [];
        for (var i = 0; i < snap.items.length; i++) {
          var title = snap.items[i].product_title || snap.items[i].title || '';
          if (addedTitle && title === addedTitle) continue;
          if (title && otherTitles.indexOf(title) === -1) otherTitles.push(title);
        }
        if (addedTitle && otherTitles.length) {
          note.textContent =
            'Added ' + addedTitle + '. Your cart also has ' + otherTitles.slice(0, 2).join(', ') + '.';
        } else {
          note.textContent =
            'Your cart has ' +
            snap.unique_products +
            ' different products. Remove any you don’t want before checkout.';
        }
        note.classList.add('is-visible');
      } else {
        note.textContent = '';
        note.classList.remove('is-visible');
      }
    }
  }

  function rememberJustAdded() {
    try {
      var latest = window.theme.cart.store.getState().latestAddedProduct;
      if (!latest) return;
      if (latest.key) sessionStorage.setItem(JUST_ADDED_KEY, latest.key);
      if (latest.variant_id) sessionStorage.setItem(JUST_ADDED_VARIANT, String(latest.variant_id));
      sessionStorage.setItem(JUST_ADDED_TITLE, latest.product_title || latest.title || '');
    } catch (e) {}
  }

  async function addVariantToCart(variantId, quantity, source) {
    var id = String(variantId || '');
    if (!id) throw new Error('Missing variant');
    await window.theme.cart.store.getState().add({
      id: id,
      quantity: quantity || 1
    });
    await window.theme.cart.store.getState().resetVariantsBeingAdded();
    rememberJustAdded();

    var snap = cartSnapshot();
    pushFunnelEvent('sg_add_to_cart', {
      sg_source: source || 'ajax',
      sg_variant_id: id,
      sg_item_count: snap.item_count,
      sg_unique_products: snap.unique_products
    });

    openCartDrawer();
    setTimeout(function () {
      highlightJustAdded();
      updateMultiItemNote();
    }, 150);
  }

  function setBusy(el, busy) {
    if (!el) return;
    el.classList.toggle('is-adding', !!busy);
    if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
      el.disabled = !!busy;
    } else {
      el.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
  }

  function trackCartMutations() {
    var prevCount = cartSnapshot().item_count;
    var prevItems = cartSnapshot().items.slice();

    window.theme.cart.store.subscribe(function (state) {
      var products = state.products || {};
      var nextCount = products.item_count || 0;
      var nextItems = products.items || [];

      if (nextCount < prevCount) {
        pushFunnelEvent('sg_cart_item_remove', {
          sg_item_count: nextCount,
          sg_unique_products: cartSnapshot().unique_products,
          sg_prev_item_count: prevCount
        });
      } else if (nextCount === prevCount && nextItems.length === prevItems.length) {
        var qtyChanged = false;
        for (var i = 0; i < nextItems.length; i++) {
          var match = null;
          for (var j = 0; j < prevItems.length; j++) {
            if (prevItems[j].key === nextItems[i].key) {
              match = prevItems[j];
              break;
            }
          }
          if (match && match.quantity !== nextItems[i].quantity) {
            qtyChanged = true;
            break;
          }
        }
        if (qtyChanged) {
          pushFunnelEvent('sg_cart_qty_change', {
            sg_item_count: nextCount,
            sg_unique_products: cartSnapshot().unique_products
          });
        }
      }

      prevCount = nextCount;
      prevItems = nextItems.slice();
      updateMultiItemNote();
    });
  }

  function trackCheckoutClicks() {
    document.addEventListener(
      'click',
      function (e) {
        var target = e.target;
        if (!target || !target.closest) return;

        var inCart =
          target.closest('.js-cart-draw') ||
          target.closest('.mfp-cart-draw') ||
          target.closest('cart-full');
        if (!inCart) return;

        var checkoutBtn =
          target.closest('button[name="checkout"]') ||
          target.closest('.cart__checkout') ||
          target.closest('.shopify-payment-button') ||
          target.closest('.additional-checkout-buttons');
        if (!checkoutBtn) return;

        var snap = cartSnapshot();
        var isExpress = !!(
          checkoutBtn.closest('.additional-checkout-buttons') ||
          checkoutBtn.classList.contains('additional-checkout-buttons') ||
          checkoutBtn.closest('.shopify-payment-button')
        );
        pushFunnelEvent('sg_cart_drawer_checkout', {
          sg_item_count: snap.item_count,
          sg_unique_products: snap.unique_products,
          sg_line_count: snap.line_count,
          sg_checkout_type: isExpress ? 'express' : 'checkout'
        });
      },
      true
    );
  }

  whenCartReady(function () {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.classList || !form.classList.contains('js-sg-ajax-cart')) return;
        if (!window.theme.cart_ajax) return;

        e.preventDefault();
        e.stopPropagation();

        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var button = form.querySelector('[type="submit"]');
        var variantId = idInput && idInput.value;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var source = form.closest('.sg-sticky-atc')
          ? 'homepage_sticky'
          : form.closest('.sg-hero-card')
            ? 'homepage_hero'
            : form.closest('.sg-lineup-card')
              ? 'homepage_lineup'
              : 'ajax_form';

        setBusy(button, true);
        addVariantToCart(variantId, qty, source)
          .catch(function (err) {
            console.error(err);
            window.alert(err && err.message ? err.message : 'Could not add to cart');
          })
          .finally(function () {
            setBusy(button, false);
          });
      },
      true
    );

    trackCartMutations();
    trackCheckoutClicks();
    initStickyAtc();
  });

  function initStickyAtc() {
    var bar = document.querySelector('[data-sg-sticky-atc]');
    var sentinel = document.querySelector('[data-sg-sticky-sentinel]');
    if (!bar || !sentinel) return;

    var mq = window.matchMedia('(max-width: 749px)');

    function sync() {
      if (!mq.matches) {
        bar.setAttribute('hidden', '');
        return;
      }
      // visibility driven by IntersectionObserver below
    }

    if (!('IntersectionObserver' in window)) {
      // Fallback: show sticky on mobile after short scroll
      var onScroll = function () {
        if (!mq.matches) {
          bar.setAttribute('hidden', '');
          return;
        }
        if (window.scrollY > 420) bar.removeAttribute('hidden');
        else bar.setAttribute('hidden', '');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      mq.addEventListener ? mq.addEventListener('change', onScroll) : mq.addListener(onScroll);
      onScroll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        if (!mq.matches) {
          bar.setAttribute('hidden', '');
          return;
        }
        var entry = entries[0];
        if (entry && entry.isIntersecting) bar.setAttribute('hidden', '');
        else bar.removeAttribute('hidden');
      },
      { root: null, threshold: 0, rootMargin: '0px' }
    );

    io.observe(sentinel);
    var onMq = function () {
      sync();
      if (!mq.matches) bar.setAttribute('hidden', '');
    };
    mq.addEventListener ? mq.addEventListener('change', onMq) : mq.addListener(onMq);
    sync();
  }

  /* Low-res first → swap to high-res when near viewport */
  function upgradeLineupImage(img) {
    if (!img || img.dataset.sgHiresDone === '1') return;
    var hiSrc = img.getAttribute('data-sg-hires-src');
    if (!hiSrc) return;
    img.dataset.sgHiresDone = '1';

    var probe = new Image();
    var srcset = img.getAttribute('data-sg-hires-srcset');
    var sizes = img.getAttribute('data-sg-hires-sizes');
    if (srcset) probe.srcset = srcset;
    if (sizes) probe.sizes = sizes;
    probe.onload = function () {
      if (srcset) img.srcset = srcset;
      if (sizes) img.sizes = sizes;
      img.src = hiSrc;
      img.width = 960;
      img.height = 960;
      img.classList.add('is-hires');
      img.classList.remove('sg-lineup-card__image--lqip');
    };
    probe.onerror = function () {
      img.classList.add('is-hires');
      img.classList.remove('sg-lineup-card__image--lqip');
    };
    probe.src = hiSrc;
  }

  function initLineupHires() {
    var imgs = document.querySelectorAll('img[data-sg-hires-src]');
    if (!imgs.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < imgs.length; i++) upgradeLineupImage(imgs[i]);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          upgradeLineupImage(entries[i].target);
          io.unobserve(entries[i].target);
        }
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    for (var j = 0; j < imgs.length; j++) io.observe(imgs[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLineupHires);
  } else {
    initLineupHires();
  }
})();
